import type { SVGProps } from 'react';

/** Japan — white field with a red disc. Decorative (`aria-hidden`); see `GbFlag` for sizing/crop notes. */
export const JpFlag = ({ width = '17', height = '12', ...props }: SVGProps<SVGSVGElement>) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 60 30"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        {...props}>
        <rect width="60" height="30" fill="#fff" />
        <circle cx="30" cy="15" r="9" fill="#BC002D" />
    </svg>
);
